// @flow
import * as React from 'react';
import Menu from './Menu';

const HelpMenu = () => (
  <Menu
    id="help-menu"
    label="Help"
    justify="right"
    renderItems={({ getProps }) => {
      return [
        <a
          key="documentation"
          href="http://help.powerreviews.com/Content/Moderation/Moderation%20&%20Observations.htm"
          target="_blank"
          rel="noopener noreferrer"
          {...getProps()}
        >
          Documentation
        </a>,
        // <a key="chat" href="#">
        //   Chat
        // </a>,
        <a
          key="support"
          href="http://help.powerreviews.com/Content/Contact%20Us.htm"
          target="_blank"
          rel="noopener noreferrer"
          {...getProps()}
        >
          Support
        </a>,
      ];
    }}
  />
);

export default HelpMenu;



// WEBPACK FOOTER //
// ./src/pages/__components__/HelpMenu.js